import { useLocation } from 'react-router';

import Box from '@mui/material/Box';

import Main from '../components/Main';
import Header from '../components/Header';
import MiniSideNav from '../components/MiniSideNav';
import EnvironmentBanner from '../components/EnvironmentBanner';

function DashboardLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  // Check if current path is a summary page
  const isSummaryPage = location.pathname.includes('/summary');

  return (
    <Box id="root__layout">
      <EnvironmentBanner />
      <Header />
      <Box sx={{ display: 'flex', flex: 1 }}>
        {!isSummaryPage && (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MiniSideNav />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            ...(!isSummaryPage && {
              overflow: 'hidden',
            }),
          }}
        >
          <Main>{children}</Main>
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardLayout;
